// templates/component/SystemBanner.js
import React from 'react'
import parse from "html-react-parser"; // safer than dangerouslySetInnerHTML
interface SystemBannerProps {
    text: string
    isBannerGlow: boolean
    show: boolean
    additionalClasses: string
}
function SystemBanner(props: SystemBannerProps) {
    // TODO conditional if show
    if (props.show && props.text !== "") {
        return (
            <div
                id="ctl00_site_master_main_container_signin_banner"
                className={`system-banner px-2 ${props.additionalClasses} ${props.isBannerGlow ? 'highlightBanner' : ''}`}
            >
                {parse(props.text)}
            </div>
        )
    } else {
        return <></>
    }
}

export default SystemBanner
